module.exports = __webpack_public_path__ + "img/04-3-1快速.e0c66af1.svg";